/**
 * This file holds the actions/mutations types
 * For more information about why this is needed
 * check here https://vuex.vuejs.org/guide/mutations.html#using-constants-for-mutation-types
 */

export const SET_VIEWS = "SET_VIEWS";
export const SET_ACTIVE_VIEW = "SET_ACTIVE_VIEW";
export const PREV_VIEW = "PREV_VIEW";
export const NEXT_VIEW = "NEXT_VIEW";

export const SET_ACTIVE_UGC_COMPONENT = "SET_ACTIVE_UGC_COMPONENT";
export const SET_CANVAS_CONFIG = "SET_CANVAS_CONFIG";

export const SET_IS_CREATING_ASSETS = "SET_IS_CREATING_ASSETS";

export const RESET_NAVIGATION = "RESET_NAVIGATION";

export const SET_BUTTON_BACKGROUND_IMAGE_URL = "SET_BUTTON_BACKGROUND_IMAGE_URL";
export const SET_ENABLE_CONTROLS = "SET_ENABLE_CONTROLS";

export const GET_UGC_SWATCH = "GET_UGC_SWATCH";

export const UPLOAD = "UPLOAD";

export const SET_UPLOADED_IMAGE_DATA = "SET_UPLOADED_IMAGE_DATA";

export const FETCH_PRODUCT_DATA = "FETCH_PRODUCT_DATA";

export const GET_PDM = "GET_PDM";

export const SET_COMPONENT_CONFIG = "SET_COMPONENT_CONFIG";

export const SET_AVAILABLE_MODELS = "SET_AVAILABLE_MODELS";

export const RESET_CANVAS = "RESET_CANVAS";

export const REMOVE_COMPONENT_CONFIG = "REMOVE_COMPONENT_CONFIG";

export const SET_SECOND_VIEW = "SET_SECOND_VIEW";

export const SET_SAME_UPLOAD_IMAGE = "SET_SAME_UPLOAD_IMAGE";

export const SET_TEMP_COMPONENTS = "SET_TEMP_COMPONENTS";

export const SET_COMPONENTS = "SET_COMPONENTS";

export const SET_SKIP_WARP_SELECTOR = "SET_SKIP_WARP_SELECTOR";

export const GET_CHECKERBOARD_SIZE = "GET_CHECKERBOARD_SIZE";
export const SET_CHECKERBOARD_SIZE = "SET_CHECKERBOARD_SIZE";
export const SET_PRODUCT_TYPE = "SET_PRODUCT_TYPE";

export const SET_SOURCE = "SET_SOURCE";
